import React from 'react';
import injectSheet from 'react-jss';

import { cx } from 'helpers';
import { BASE_COLOR } from 'shared/constants/colors';


/*
 * Material Design Circular Spinner
 * Reference: https://codepen.io/jczimm/pen/vEBpoL
 */

// const colors = keyframes`
//   0%   { stroke: #4285F4; }
//   25%  { stroke: #DE3E35; }
//   50%  { stroke: #F7C223; }
//   75%  { stroke: #1B9A59; }
//   100% { stroke: #4285F4; }
// `;

let CircularSpinner = ({classes: cn, size = 32, strokeWidth = 2, style = {}}) => {
  const width = `${size}px`;

  return (
    <div className={cn.root} style={{...style, width}}>
      <svg
        className={cn.svg}
        style={{width}}
        viewBox='25 25 50 50'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle
          className={cn.circle}
          strokeWidth={strokeWidth}
          cx='50' cy='50' r='20' fill='none'
          strokeMiterlimit='10'
        />
      </svg>
    </div>
  );
};
CircularSpinner = injectSheet({
  root: {  // width to be defined dynamically
    position: 'relative',
    '&:before': {
      content: '""',
      display: 'block',
      paddingTop: '100%',
    },
  },
  svg: {  // width to be defined dynamically
    animation: 'CircularSpinner-rotate 1.8s linear infinite',
    transformOrigin: 'center center',
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  circle: {
    // TODO: Maybe make the color dynamic
    stroke: `${BASE_COLOR.darkGray}`,
    strokeDasharray: '1, 200',
    strokeDashoffset: '0',
    animation: 'CircularSpinner-dash 1.5s ease-in-out infinite',
    strokeLinecap: 'round',
  },
})(CircularSpinner);


/*
 * Double Bounce Spinner
 * Reference: http://kyleamathews.github.io/react-spinkit/
 */
let DoubleBouncer = ({classes: cn, color = '#E5FCC2', size = 14}) => {
  const _size = `${size}px`;
  const backgroundColor = color;

  return (
    <div
      className="relative"
      style={{width: _size, height: _size}}
    >
      <div className={cn.bounce} style={{backgroundColor}} />
      <div className={cx(cn.bounce, cn.bounceDelay)} style={{backgroundColor}} />
    </div>
  );
};
DoubleBouncer = injectSheet({
  bounce: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    borderRadius: '50%',
    opacity: 0.6,
    animation: 'DoubleBouncer-bounce 1.6s infinite ease-in-out',
  },
  bounceDelay: {
    animationDelay: '-0.8s',
  },
})(DoubleBouncer);


/*
 * MgTextLogoBouncer
 *
 * References: (for different tracer effect)
 * https://sarasoueidan.com/blog/svg-coordinate-systems/
 * http://codepen.io/ClaireLarsen/pen/XmVyVX/
 * https://gist.github.com/thomaswhyyou/9580a49ff7df9c913010115b6c43311c
 * http://jxnblk.com/writing/posts/static-site-generation-with-react-and-webpack/
 * https://github.com/markdalgleish/static-site-generator-webpack-plugin
 */

// XXX: Delete moa-mg-text-logo deprecated..
const MgTextLogoBouncer = ({style = {}, className}) => {
  return (
    <div
      className={cx('moa-mg-text-logo', className)}
      style={style}
    ></div>
  );
};


/*
 * Squiggly thingy
 *
 * https://www.news47ell.com/articles/use-svg-css-instead-text-decoration-underline/
 */
const Squiggly = (props) => <div className="bg-squiggly" {...props} />;


export {
  CircularSpinner,
  DoubleBouncer,
  MgTextLogoBouncer,
  Squiggly,
};



// WEBPACK FOOTER //
// ./src/components/elems/Progress.js